// extracted by mini-css-extract-plugin
export default {"Loader":"Loading_Loader__Au3Qr","Loader__circle":"Loading_Loader__circle__OzJXv","spinner":"Loading_spinner__iyhvB"};